/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Outcome_ExcessInputs */

const en_inbound_outcome_excess = /** @type {(inputs: Inbound_Outcome_ExcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Units in more`)
};

/**
* | output |
* | --- |
* | "Units in more" |
*
* @param {Inbound_Outcome_ExcessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_outcome_excess = /** @type {((inputs?: Inbound_Outcome_ExcessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Outcome_ExcessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_outcome_excess(inputs)
});